const NS = 'HomePageCarouselBlock';
const CLS = 'homePageCarouselBlock';

export class HomePageCarouselBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.$carouselSlider = this.$element.find(`.${CLS}-slider`);
		this.$carouselItems = this.$element.find(`.${CLS}-item`);
		this.$carouselImgContainer = this.$carouselItems.find(`.${CLS}-item-imgContainer`);

		this.$arrowContainer = this.$element.find(`.${CLS}-arrow-container`);
		this.$dotsContainer = this.$element.find(`.${CLS}-dots-container`);

		this.$carouselSlider.slick({
			dots: true,
			dotsClass: `slick-dots`,
			appendArrows: this.$arrowContainer,
			appendDots: this.$dotsContainer,
			nextArrow: `<button type="button" class="slick-arrow slick-arrow--next"><i class="slick-arrow-icon icon icon--chevron-lg-right"></i></button>`,
			prevArrow: `<button type="button" class="slick-arrow slick-arrow--previous"><i class="slick-arrow-icon icon icon--chevron-lg-left"></i></button>`,
			infinite: false,
			cssEase: 'ease-in-out',
			useTransform: true,
			fade: true,
			speed: 750,
			autoplay: true,
  			autoplaySpeed: 4000
			
		});

		// Display the carousel
		this.$carouselItems.css({ display: 'block' });
	}
}
